import { render, staticRenderFns } from "./Causes.vue?vue&type=template&id=e45a5f96"
import script from "./Causes.vue?vue&type=script&lang=js"
export * from "./Causes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports